var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartBg2Components(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1922,
    height: 820,
    viewBox: "0 0 1922 820",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.4,
    filter: "url(#filter1_f_2128_17362)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 -93C37.8333 -35.6667 -97.4 86.3 -121 115.5L1006.5 650L102.5 -93Z",
    fill: "url(#paint0_linear_2128_17362)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2128_17362",
    x: -284.4,
    y: -256.4,
    width: 1454.3,
    height: 1069.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 81.7,
    result: "effect1_foregroundBlur_2128_17362"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2128_17362",
    x1: -6.49999,
    y1: 8,
    x2: 956.5,
    y2: 634.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7FFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartBg2Components);
export default __webpack_public_path__ + "static/media/StartBg2Components.aca4c9791f5a55e981740dc1f0be67b9.svg";
export { ForwardRef as ReactComponent };